module.exports = __webpack_public_path__ + "static/img/zynt.fbed5d77.png";